import { createElementBlock as l, openBlock as n, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return n(), l("svg", o, e[0] || (e[0] = [
    t("path", {
      fill: "#117ACA",
      "fill-rule": "evenodd",
      d: "M9.2 4.642c0-.306.248-.554.554-.554h5.038l4.676 4.442H9.2zm10.09 4.51c.308 0 .554.247.554.554l-.002 5.037-4.44 4.678V9.151zm-5.065 10.64a.555.555 0 0 0 .554-.555v-3.886H4.51l4.677 4.441zm-9.535-5.06a.556.556 0 0 1-.555-.556V9.139l4.44-4.677v10.27z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: r };
export {
  i as default,
  r as render
};
//# sourceMappingURL=ic_payment_chase-CUwDlugE.js.map
